// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'name',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'status',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'site',
    Object: 'value',
    label: '',
    width: '150'
  }, {
    prop: 'level',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'ticket_type',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'online',
    label: '',
    Object: 'value',
    width: '120'
  }]
}
